import React, { useMemo } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface YearSelectProps {
  year: number;
  onChange: (year: number) => void;
  fromYear?: number;
  toYear?: number;
  className?: string;
}

const YearSelect: React.FC<YearSelectProps> = ({ year, onChange, fromYear, toYear, className }) => {
  const now = new Date().getFullYear();
  const end = toYear ?? now;
  const start = fromYear ?? now - 5;

  const years = useMemo(() => {
    const arr: number[] = [];
    for (let y = end; y >= start; y--) arr.push(y);
    return arr;
  }, [start, end]);

  return (
    <Select value={String(year)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger className={className || 'w-full'} aria-label="Έτος">
        <SelectValue placeholder="Επιλέξτε έτος" />
      </SelectTrigger>
      <SelectContent className="z-50">
        {years.map((y) => (
          <SelectItem key={y} value={String(y)}>
            {y}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default YearSelect;
